export default {
  profile: '/profile',
  leave_applications: '/leave-applications',
  myleave: '/my-leave',
  claim_approvals: '/claim-approvals',
  claim_on_behalf: '/claim-on-behalf',
  myclaim: '/my-claim',
  my_e_letters: '/e-letter',
}
